import { useCallback, useState } from 'react'
import { Input, Row, Col, Icon } from '@iqueue/ui-kit'
import { t } from '../../../hooks/useTranslate'

export default function SettingsChips1({ chips, onChange }) {
  const [inputValue, setInputValue] = useState('')
  const [draggingChip, setDraggingChip] = useState(null)
  const [placeholderIndex, setPlaceholderIndex] = useState(null)

  const handleAddChip = useCallback(() => {
    if (inputValue.trim() && !chips.includes(inputValue.trim())) {
      onChange([...chips, inputValue.trim()])
      setInputValue('')
    }
  }, [inputValue, chips])

  const handleDeleteChip = useCallback((indexToDelete) => {

    onChange((prevChips) => {
        return prevChips.filter((_, index) => index !== indexToDelete)
      },
    )
  }, [onChange])

  const handleDragStart = useCallback((chip, index) => {
    setDraggingChip(index)
  }, [])

  const handleDragOver = useCallback((e, index) => {
    e.preventDefault()

    const rect = e.target.getBoundingClientRect()
    const offset = e.clientX - rect.left

    if (offset < rect.width / 2) {
      setPlaceholderIndex(index)
    } else {
      setPlaceholderIndex(index + 1)
    }
  }, [])

  const handleDrop = useCallback(() => {
    if (draggingChip !== null && placeholderIndex !== null) {
      const updatedChips = [...chips]

      const [removedChip] = updatedChips.splice(draggingChip, 1)

      const insertIndex = placeholderIndex > draggingChip ? placeholderIndex - 1 : placeholderIndex
      updatedChips.splice(insertIndex, 0, removedChip)

      onChange(updatedChips)
    }

    setDraggingChip(null)
    setPlaceholderIndex(null)
  }, [draggingChip, placeholderIndex, chips])

  return <div className="chips-autocomplete-container">
    <b>{ t('settingsPage.chips.excelFieldOrder') }</b>
    <Row>
      <Input
        size={ 12 }
        value={ inputValue }
        onChange={ (value) => setInputValue(value) }
        onKeyDown={ (e) => {
          if (e.key === 'Enter') handleAddChip()
        } }
        placeholder={ t('settingsPage.chips.addItemPlaceholder') }
        name={ 'chips' }
      />
    </Row>
    <Row>
      <Col size={ 12 }>
        <div className="chips-list">
          { chips?.map((chip, index) => {
            return <div
              key={ chip }
              className={ `chip ${ draggingChip === chip ? 'dragging' : '' }` }
              draggable
              onDragStart={ () => handleDragStart(chip, index) }
              onDragOver={ (e) => handleDragOver(e, index) }
              onDrop={ handleDrop }
            >
              { placeholderIndex === index && <div className="drop-placeholder"/> }

              <span className="main-chip">{ chip }</span>
              <span
                className="chip-delete"
                onClick={ () => handleDeleteChip(index) }
              >
                  <Icon>delete</Icon>
                </span>
            </div>
          }) }

          { placeholderIndex === chips?.length && <div className="drop-placeholder-right"/> }
        </div>
      </Col>
    </Row>
  </div>
}
